import { useQuery } from '@tanstack/react-query';
import { getGenders } from '@uplift/api';
import { BaseQueryOpts } from './baseTypes';

export const useGendersQuery = (opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'genders' ],
    queryFn: getGenders,
    select: (data) => data.data,
    ...opts,
  });
};
